import { ConfigurationState } from '../types/configuration';
import { formatTimeSpan, findSelectedItem } from '../utils/configurationUtils';
import { ConfigGroup } from '../types/configuration';
import dataProvider from '../../services/api';

export const useConfigurationService = () => {

  const updateConfiguration = async (
    selectedItem: string,
    configGroups: ConfigGroup[],
    configState: ConfigurationState,
    showSuccessMessage: (message: string) => void,
    handleErrorWithLogout: (error: any) => void
  ) => {
    const item = findSelectedItem(configGroups, selectedItem);
    if (item && item.apiName) {
      try {
        let valueToSend: string;
        const currentGroup = configGroups.find(group => group.items.some(i => i.id === selectedItem));
        
        if (currentGroup && currentGroup.name === 'Email Templates') {
          valueToSend = configState.htmlValue;
        } else if (item.dataType === 'TimeSpan') {
          const days = parseInt(configState.selectedDays) || 0;
          const hours = configState.selectedTime ? configState.selectedTime.hour() : 0;
          const minutes = configState.selectedTime ? configState.selectedTime.minute() : 0;
          const seconds = configState.selectedTime ? configState.selectedTime.second() : 0;
          valueToSend = formatTimeSpan(days, hours, minutes, seconds);
        } else {
          valueToSend = configState.selectedValue;
        }

        await dataProvider.updateConfigurationValue({
          name: item.apiName,
          value: valueToSend,
        });
        
        showSuccessMessage('Configuration updated successfully!');
      } catch (error: any) {
        handleErrorWithLogout(error);
        throw error;
      }
    }
  };

  return { updateConfiguration };
};